import {Injectable, Injector} from "@angular/core";
import {OutletData} from "./outlet.data";
import {EntityModel} from "@fedeltapointofsale/data-client";

@Injectable()
export class OutletEntityModel extends EntityModel<OutletData> {

    constructor(injector: Injector) {
        super(injector, OutletData);
    }
}
